import type { FontWeights } from './types';

export const fontWeights: FontWeights = {
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};
